var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiAlza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload-Icono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 1.30005L5.20013 11.9364L10.1638 11.9364L10.1638 24.7L15.8365 24.7L15.8365 11.9364L20.8001 11.9364L13.0001 1.30005Z",
    id: "Forma",
    fill: "#304278",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiAlza);
export default __webpack_public_path__ + "static/media/kpi_alza.62e56e4b38f3b299ad6c6d223a8e852d.svg";
export { ForwardRef as ReactComponent };